import { render, staticRenderFns } from "./BankIcon.vue?vue&type=template&id=2479af59"
import script from "./BankIcon.vue?vue&type=script&lang=ts"
export * from "./BankIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports